import { ThunkDispatch } from 'redux-thunk';
import { Auth } from '@jg/auth';
import { Action } from 'redux';
import { IAppState } from '../../types/state.d';
import {
  getAppDataRequestMade,
  getAppDataRequestSuccess,
  getAppDataRequestError,
} from '../actionCreators/apiActions';

import fetchTeamData from './fetchTeamData';
import fetchEventDetails from './fetchEventDetails';
import fetchLockData from './fetchLockData';
import fetchFundraisingPages from './fetchFundraisingPages';

const fetchAppData = (teamGuid: string) => async (
  dispatch: ThunkDispatch<IAppState, Auth, Action>,
  getState: () => IAppState,
) => {
  try {
    const {
      router: {
        location: { pathname },
      },
    } = getState();

    const isJoin = new RegExp(/join/i).test(pathname);
    dispatch(getAppDataRequestMade());
    await dispatch(fetchTeamData(teamGuid));
    await dispatch(fetchLockData(teamGuid));
    if (isJoin) {
      await dispatch(fetchFundraisingPages(teamGuid));
    }
    await dispatch(fetchEventDetails());
    dispatch(getAppDataRequestSuccess());
  } catch (error) {
    dispatch(getAppDataRequestError(error.message));
  }
};

export default fetchAppData;
